import iconCross from 'assets/icons/icon-cross-black.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'reactstrap';

const BottomSheet = ({
  id = 'BottomSheet',
  isOpen,
  btnFunc,
  sheetTitle,
  sheetDesc,
  btnText,
  layoutBody,
  layoutButton,
  isPrimaryButtonBlock,
  img,
  textBodyAlign,
  toggle,
  children,
  disableClose,
  className,
  btnId,
  onClose
}) => {
  return (
    <div>
      <Modal
        id={id}
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          margin: 'auto',
          transform: 'translate(0,0)',
          left: 0,
          right: 0
        }}
        isOpen={isOpen}
        toggle={toggle}
        className={className}
        onClosed={onClose}
      >
        <div className="p-3 position-relative">
          {!disableClose && (
            <img
              data-testid="close-button"
              className="position-absolute"
              src={iconCross}
              onClick={() => {
                toggle();
                onClose();
              }}
            />
          )}
          {children ? (
            children
          ) : (
            <>
              <div style={{ backgroundColor: '#f7f7f7' }}>
                <object
                  data={img}
                  style={{ display: 'block', margin: '0 auto' }}
                  className="mb-3"
                />
              </div>
              <div className="mb-2 font-weight-bold size-font-300">
                {sheetTitle}
              </div>
              {layoutBody || (
                <div
                  className={`color-black-300 font-weight-medium size-font-100 mb-4 text-${textBodyAlign}`}
                >
                  {sheetDesc}
                </div>
              )}
              {layoutButton || (
                <Button
                  id={btnId}
                  color="primary"
                  onClick={btnFunc || toggle}
                  block={isPrimaryButtonBlock}
                >
                  {btnText}
                </Button>
              )}
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

BottomSheet.displayName = 'BottomSheet';

BottomSheet.defaultProps = {
  isOpen: false,
  btnFunc: () => {},
  sheetTitle: '',
  sheetDesc: '',
  btnText: 'Lanjutkan',
  layoutBody: null,
  layoutButton: null,
  isPrimaryButtonBlock: true,
  img: null,
  textBodyAlign: 'left',
  toggle: () => {},
  children: null,
  disableClose: false,
  className: null,
  btnId: null,
  onClose: () => {}
};

BottomSheet.propTypes = {
  isOpen: PropTypes.bool,
  btnFunc: PropTypes.func,
  sheetTitle: PropTypes.string,
  sheetDesc: PropTypes.string,
  btnText: PropTypes.string,
  layoutBody: PropTypes.element,
  layoutButton: PropTypes.element,
  isPrimaryButtonBlock: PropTypes.bool,
  img: PropTypes.string,
  textBodyAlign: PropTypes.oneOf(['left', 'center', 'right']),
  toggle: PropTypes.func,
  children: PropTypes.element,
  disableClose: PropTypes.bool,
  className: PropTypes.string,
  btnId: PropTypes.string,
  onClose: PropTypes.func
};

export default BottomSheet;
